import React, { useState, useEffect, useContext } from 'react'
import { connect } from 'react-redux'
import moment from 'moment'

import { getTrainingClassList, fetchTrainingClassList } from '../../../store/client'

import { NavigationContext } from '../../../shared/ui/NavigationController'
import ListViewController from '../../../shared/ui/ListViewController'
import {capitalize} from '../../../shared/utilities/helpers'
import StatusLabel from '../../../shared/ui/StatusLabel'
import DateCard from '../../../shared/ui/DateCard'
import { formatValue } from '../../../shared/ui/TableData'

import { withStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import Box from '@material-ui/core/Box'
import AddIcon from '@material-ui/icons/Add'
import LanguageIcon from '@material-ui/icons/Language'
import BusinessIcon from '@material-ui/icons/Business'
import GroupIcon from '@material-ui/icons/Group'

const styles = theme => ({
  root: {
  },
  iconLabel: {
    color: theme.palette.primary.main,
    marginRight: theme.spacing(0.5)
  }
})

const TrainingClassListController = ({ theme, classes, ...props }) => {
  const { isFetching, lastFetched, data, fetchTrainingClassList } = props
  
  const navigationContext = useContext(NavigationContext)
  const [selectedGroupKey, setSelectedGroupKey] = useState("upcoming")

  useEffect(() => {
    fetchTrainingClassList()
  }, [])  

  const groups = [
    { key: 'upcoming', label: 'Upcoming' },
    { key: 'completed', label: 'Completed' },
    { key: 'canceled', label: 'Canceled' },
  ]

  const TrainingClassStatusColor = {
    'Draft': '#ffaa00',
    'Registration Open': '#0000ff',
    'Ready to Deliver': '#00aa00',
    'Canceled': '#aaaaaa',
    'Completed': '#000000'    
  }
  
  const columns = [
    { key: 'primary_image_url', label: '', type: 'image', aspectRatio: 1.75, width: theme.spacing(12) },
    { key: 'name', label: 'Course', variant: 'title' },
    { key: 'training_date', label: 'Date', wordWrap: false },
    { key: 'venue', label: 'Delivery' },
    { key: 'trainer_name', label: 'Trainer' },
    { key: 'class_type', label: 'Class Type', wordWrap: false },
    { key: 'price_per_participant', label: 'Price', wordWrap: false },
    { key: 'status', label: 'Status', wordWrap: false }
  ]

  const today = new Date()
  today.setHours(0, 0, 0, 0)

  const applyFilter = (list, key) => {
    if (key == 'upcoming')
      return list.filter(p =>
        !p.canceled_at && !p.completed_at && (!p.released_at || moment(p.training_date).toDate() > today))
    else if (key == 'completed')
      return list.filter(p =>
        !p.canceled_at && p.released_at && (p.completed_at || moment(p.training_date).toDate() < today)
        )
    else if (key == 'canceled')
      return list.filter(p =>
        p.canceled_at
        )                
      return []    
  }
  
  const getCellValue = (row, column) => {
    if (column.key === 'name')
      return row.course ? row.course.name : ''
    else if (column.key === 'primary_image_url')
      return row.course && row.course.primary_image_url
    else if (column.key === 'trainer_name')
      return row.trainer ? (row.trainer.first_name + ' ' + row.trainer.last_name) : ''
    else if (column.key === 'venue')
      return row['delivery_method'] !== 'online' ? capitalize(row['delivery_method']) + ' Class' : capitalize(row['delivery_method']) + ' Class via '+row['delivery_app']
    else if (column.key === 'class_type')
      return (
        <Box>
          <Box display='flex' alignItems='center'>
            { row.customer_type !== 'public' ?
              <>
                <BusinessIcon className={classes.iconLabel} style={{ color: 'black' }} />
                <Typography>Private</Typography>
              </>
              :
              <>
                <LanguageIcon className={classes.iconLabel} style={{ color: 'black' }}/>
                <Typography variant='body1'>Public</Typography>
              </>
            }
          </Box>
          <Box display='flex' alignItems='center'>
            <GroupIcon className={classes.iconLabel} style={{ color: '#888' }}/>
            <Typography variant='body2' className={classes.muted}>
              { row.participant_count + ' pax' }
            </Typography>
          </Box>
        </Box>
      )
    else if (column.key === 'training_date')
      // return moment().format('DD MMM YYYY')
      return (
        <Box display='flex'>
          { row.schedules && row.schedules.length > 0 && row.schedules.map(item => 
            <DateCard item={ item.training_date }/>
          )}
          { row.schedules && row.schedules.length <= 0 &&
            <DateCard item={ row.training_date }/>
          }
        </Box>
      )
    else if (column.key === 'status')
      return (
        <StatusLabel
          color={TrainingClassStatusColor[row.status] || '#555'}
          >
          { row.status }
        </StatusLabel>
      )

    else if (column.key === 'price_per_participant')
      return formatValue(row[column.key], "currency") + '/pax'
      
    else
      return row[column.key]
  }
  
  const getCellSecondaryValue = (row, column) => {
    if (column.key == 'name')
      return row.training_class_no
    // else if (column.key == 'client_name')
    //   return row.participant_count + ' pax'
    // else if (column.key === 'training_date')
    //     return secondsToTime(row.start_time) +"-" + secondsToTime(row.end_time) +" "
  }
  
  const showTrainingClassDetail = (row) => {
    navigationContext.openLink(`/company/trainingclass/view/${row.uid}`)
  }

  const groupCount = (key) => {
    return (
        lastFetched && applyFilter(data.records, key).length
      ) || 0
  }
  
  const rows = (
    lastFetched && applyFilter(data.records, selectedGroupKey)
    ) || [] 
  
  return (
    <ListViewController
      title="Upcoming Classes"
      groups={groups}
      columns={columns}
      lastFetched={lastFetched}      
      isFetching={isFetching}
      rows={rows}
      getCellValue={getCellValue}
      getCellSecondaryValue={getCellSecondaryValue}
      onRowClick={(row) => showTrainingClassDetail(row)}
      onGroupChange={group => setSelectedGroupKey(group.key)}
      getRowsCount={groupCount}
      selectedGroupKey={selectedGroupKey}
      >
        { lastFetched && rows.length <= 0 &&
          <Box mt={2} display='flex' justifyContent='center'>
            <Typography variant='body1'>
              You have no {selectedGroupKey.replace(/-/gi, ' ')} classes.
            </Typography>
          </Box>
        }
    </ListViewController>
  )
}

const mapStateToProps = (state, ownProps) => {
  return {
    ...getTrainingClassList(state),
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    fetchTrainingClassList: () => {
      dispatch(fetchTrainingClassList(true))
    },
  }
}

export default withStyles(styles, { withTheme: true })(
  connect(
    mapStateToProps,
    mapDispatchToProps
   )(TrainingClassListController)
)
